import { render, staticRenderFns } from "./EmployeeLeaveDetails.vue?vue&type=template&id=772ea15a"
import script from "./EmployeeLeaveDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveDetails.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeaveDetails.vue?vue&type=style&index=0&id=772ea15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports